import React from "react";
import styled from "styled-components";
import { string, node } from "prop-types";

import { prop } from "../../../../shared/utils";

export const Content = styled.div`
  align-self: flex-start;
  margin-left: 1rem;
  margin-top: 1.5rem;
`;

export const Headline = styled.h2`
  margin-top: 0;
  color: ${prop("progressBarColor")};
  text-transform: uppercase;
  font-size: 1.4rem;
`;

const ContentContainer = ({ progressBarColor, title, children, ...props }) => (
  <Content {...props}>
    <Headline progressBarColor={progressBarColor}>{title}</Headline>
    {children}
  </Content>
);

ContentContainer.propTypes = {
  children: node,
  progressBarColor: string,
  title: string,
};

export default ContentContainer;
